import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Link } from '@one-thd/sui-atomic-components';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';

const { number } = PropTypes;

export const HomeServicesSubList = ({ service, subCategoryLimit }) => {
  const [viewAllSubCategories, setViewAllSubCategories] = useState(true);
  const { storeServiceSubCategories } = service;

  useEffect(() => {
    setViewAllSubCategories(false);
  }, []);

  const getSubCategoriesList = () => {
    const maxElementsToShow = viewAllSubCategories ? storeServiceSubCategories?.length : subCategoryLimit;

    return storeServiceSubCategories?.slice(0, maxElementsToShow);
  };

  return (
    <>
      <ul>
        {
          getSubCategoriesList().map((category, index) => (
            <li
              className="sui-mb-2"
              key={category.name + index}
            >
              <Link
                decoration="underline"
                color="primary"
                href={category?.leadPageUrl}
              >
                {category?.name}
              </Link>
            </li>
          ))
        }
      </ul>
      {(storeServiceSubCategories?.length > subCategoryLimit)
        && (
          <div className="sui-flex sui-items-center sui-justify-center">
            <Button
              variant="text"
              endIcon={viewAllSubCategories ? ArrowUp : ArrowDown}
              onClick={() => setViewAllSubCategories(!viewAllSubCategories)}
            >
              {viewAllSubCategories ? 'Show Less' : 'Show More'}
            </Button>
          </div>
        )}
    </>
  );

};

HomeServicesSubList.displayName = 'HomeServicesSubList';

HomeServicesSubList.propTypes = {
  service: PropTypes.shape({
    storeServiceSubCategories: PropTypes.shape([])
  }).isRequired,
  subCategoryLimit: number.isRequired,
};
